<script lang="ts">
    import type {PublicStatsData} from '../../types';
    import {exists} from 'shared/utils/custom-utils';
    import {getLocalization} from 'core/svelte-context/context';
    import KpStatsNumberInfoBox from '../../components/KpStatsNumberInfoBox.svelte';
    import KpStatsInfoGrid from '../../components/KpStatsInfoGrid.svelte';
    import KpTitledSection from 'shared/layouts/containers/KpTitledSection.svelte';

    export let statsData: PublicStatsData;
    const localize = getLocalization();

    $: documentsByDatabases = exists(statsData.stats.result.documentsByDatabasesCounts);
</script>

<KpTitledSection title="{documentsByDatabases
                                ? localize(/* @kp-localization statistiky.StatistikyDatabazi */ 'statistiky.StatistikyDatabazi')
                                : localize(/* @kp-localization statistiky.OverallStats */ 'statistiky.OverallStats')}"
                 additionalClasses="stats-general-info"
                 headingType="h3">

    <KpStatsInfoGrid>
        {#if !documentsByDatabases}
            <KpStatsNumberInfoBox icon="user"
                                  label="{localize(/* @kp-localization statistiky.pocetZaregistrovanychCtenaru */ 'statistiky.pocetZaregistrovanychCtenaru')}"
                                  value="{statsData.stats.result.registeredReadersCount.count}"/>

            <KpStatsNumberInfoBox icon="document"
                                  label="{localize(/* @kp-localization statistiky.pocetDokumentuVKnihovne */ 'statistiky.pocetDokumentuVKnihovne')}"
                                  value="{statsData.stats.result.documentsCount.count}"/>

            <KpStatsNumberInfoBox icon="book-alt"
                                  label="{localize(/* @kp-localization statistiky.pocetExemplaruVKnihovne */ 'statistiky.pocetExemplaruVKnihovne')}"
                                  value="{statsData.stats.result.exemplarsCount.count}"/>

            <KpStatsNumberInfoBox icon="book-circle-arrow-right"
                                  label="{localize(/* @kp-localization statistiky.pocetAktivnichVypujcek */ 'statistiky.pocetAktivnichVypujcek')}"
                                  value="{statsData.stats.result.activeLoansCount.count}"/>

            <KpStatsNumberInfoBox icon="globe"
                                  label="{localize(/* @kp-localization statistiky.pocetAktivnichEVypujcek */ 'statistiky.pocetAktivnichEVypujcek')}"
                                  value="{statsData.stats.result.activeELoansCount.count}"/>
        {:else}
            {#each statsData.stats.result.documentsByDatabasesCounts.counts as documentsInDatabases}
                <KpStatsNumberInfoBox label="{documentsInDatabases.name}"
                                      value="{documentsInDatabases.value}"/>
            {/each}
        {/if}
    </KpStatsInfoGrid>
</KpTitledSection>